<template>
  <el-dialog
    v-drag
    title="备注修改"
    :visible.sync="dialogVisible"
    width="500px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div v-loading="loading" class="content">
      <el-form ref="form" class="form" :model="form">
        <el-form-item prop="remark" label="备注">
          <el-select
            v-model="form.remark"
            style="width: 100%"
            placeholder="请选择备注"
            filterable
          >
            <el-option
              v-for="item in remarkOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark1" label="备注1">
          <el-input
            v-model="form.remark1"
            style="width: 100%"
            placeholder="请输入备注1"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import { modifyMBLRemark } from '@/api/bill'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      form: {
        remark: '',
        remark1: ''
      },
      remarkOption: [{
        value: '已发清关资料',
        label: '已发清关资料'
      }, {
        value: '已确认7501',
        label: '已确认7501'
      }],
      loading: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.form = {
            remark: this.rowData.remark,
            remark1: this.rowData.remark1
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          try {
            this.loading = true
            const res = await modifyMBLRemark({
              ...this.form,
              mblId: this.rowData.id
            })
            this.loading = false
            if (res.success) {
                this.$message.success('修改成功')
                this.$emit('ok')
            } else {
                this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: auto;
  margin: 0 auto;
  text-align: left;
  .form {
    margin-left: 40px;
  }
  .error {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 40px;
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}

.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
